'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Button = require('../../../../components/buttons/Button');

var _Button2 = _interopRequireDefault(_Button);

require('./ColorButton.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components
var ColorButton = function ColorButton(props) {
    var color = props.color,
        isActive = props.isActive,
        setColor = props.setColor,
        selectedType = props.selectedType;


    var onColorClick = function onColorClick(event) {
        setColor(color);
    };

    var iconStyle = color ? { background: color.hex } : {};
    var classes = {
        active: isActive,
        'no-color': !color || !color.hex
    };

    return _react2.default.createElement(
        _Button2.default,
        { className: (0, _classnames2.default)('ColorButton', selectedType, classes), onClickFn: onColorClick },
        _react2.default.createElement('div', { className: 'color-icon', style: iconStyle })
    );
};

// Styles
// Lib


ColorButton.propTypes = {
    selectedType: _propTypes2.default.string,
    color: _propTypes2.default.object,
    isActive: _propTypes2.default.bool,
    setColor: _propTypes2.default.func
};

exports.default = ColorButton;


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/toolbar/selectionTools/colorTools/ColorButton.js
// module id = 2229
// module chunks = 0